// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UDQo","actions":"styles_actions__1ub6t","error":"styles_error__36rIl","message":"styles_message__1yaoW"};